// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "cf8b80e7e9cf8228dde4" + ".chunk.min.js";
};